import { render, staticRenderFns } from "./examInfoManager.vue?vue&type=template&id=ca1be586"
import script from "./examInfoManager.vue?vue&type=script&lang=js"
export * from "./examInfoManager.vue?vue&type=script&lang=js"
import style0 from "./examInfoManager.vue?vue&type=style&index=0&id=ca1be586&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports